module.exports = new __parcel__URL__("cornershop-shopper-android.4494de11.webp").toString();